import { TextEntity } from '@wui/im'

import { entitiesToHtml } from './entities-to-html'
import { escapeHtml } from './escape-html'
import { htmlToEntities } from './html-to-entities'
import { MessageMarkupPayload, MessageMarkupSource } from './types'

export const htmlToMessagePayload = (html: string): MessageMarkupPayload => {
  const { text, entities } = htmlToEntities(html)
  if (!entities.length) {
    // Without entities messageText is rendered via v-html — escape literal "<a>" etc.
    return { messageText: escapeHtml(text) }
  }

  return {
    messageText: text,
    entities,
  }
}


export const hasMessageEntities = (entities?: TextEntity[]): entities is TextEntity[] => Boolean(entities?.length)

export const formatMessageText = (text = '', entities?: TextEntity[]): string => {
  if (!text) return text
  if (!hasMessageEntities(entities)) return text
  return entitiesToHtml(text, entities)
}

export const formatMessageMarkup = (source: MessageMarkupSource): string => {
  return formatMessageText(source.messageText ?? '', source.entities)
}

export const messageHasLink = (source: MessageMarkupSource): boolean => {
  if (hasMessageEntities(source.entities)) {
    return source.entities.some((entity) => entity.type === 'link')
  }
  return /<a\b/i.test(source.messageText ?? '')
}

export const getMessageLinkMarkup = (source: MessageMarkupSource): string[] => {
  const html = formatMessageMarkup(source)
  return html.match(/<a\b[^>]*>.*?<\/a>/giu) ?? []
}

export const countMessageLinks = (source: MessageMarkupSource): number => {
  if (hasMessageEntities(source.entities)) {
    return source.entities.filter((entity) => entity.type === 'link').length
  }
  return getMessageLinkMarkup(source).length
}

export const serializeTextEntities = (entities?: TextEntity[]): string => {
  return JSON.stringify(
    (entities ?? []).map((entity) => ({
      start: entity.start,
      end: entity.end,
      type: entity.type,
      url: entity.url,
      userId: entity.userId,
    })),
  )
}
